import { DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayout401kHistoryReport extends Layout {
    history401kDatasource: DataSource;
    switchReportType: Switch;
    textboxDrs401kHistdeductionDate: Textbox;
    textboxPayeeFilter: Textbox;
}
